
import gql from 'graphql-tag'

// """经销商修改自定义商品详情"""
export const customDealerGoodInfo = gql`
  mutation($dealerId: Int!, $goodId: Int!, $input: DealerCustomGoodInput!) {
    customDealerGoodInfo(
      dealerId: $dealerId,
      goodId: $goodId,
      input: $input
    ) {
      details
    }
  }
`

// """新建商品"""
export const createGood = gql`
  mutation($input: NewGoodInput!) {
    createGood(
      input: $input
    ) {
      author
      coverImages
      createdAt
      details
      id
      isbn
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      press
      price
      publishedDate
      status
      subTitle
      thumb
      title
      updatedAt
    }
  }
`
// """编辑商品"""
export const updateGood = gql`
  mutation($goodId: Int!, $input: EditGoodInput!) {
    updateGood(
      input: $input
      goodId: $goodId
    ) {
      author
      createdAt
      coverImages
      details
      id
      isbn
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      press
      price
      publishedDate
      status
      subTitle
      thumb
      title
      updatedAt
    }
  }
`
// 管理员修改经销商自定义商品详情
export const adminCustomDealerGoodInfo = gql`
  mutation($dealerId: Int!, $goodId: Int!, $input: AdminCustomDealerGoodInput!) {
    adminCustomDealerGoodInfo(
      dealerId: $dealerId,
      goodId: $goodId,
      input: $input
    ) {
      dealerId
      details
    }
  }
`
